//@flow

import React, { useContext } from "react";
import classnames from "classnames";
import { Field, useField } from "react-final-form";
import type { FieldRenderProps } from "react-final-form";
import { changeServiceFormInteraction } from "Commons/Utilities/GoogleTagManager";

import { RadioBasic } from "shared/formElements/Radio/RadioBasic";
import FoldableText from "modules/ChangeService/Wizard/misc/components/FoldableText/FoldableText";
import { required, composeValidators, isDate } from "modules/ChangeServiceForm/misc/validations";
import { Row, Error } from "../../shared/CommonComponents";
import ChangeServiceFormSharedContext from "../../../misc/context";
import DateInput from "../../shared/DateInput/DateInput";

type Props = {
  cancelOldContractOpts: {
    radios: Array<Object>,
    hint: Object,
  },
  inheritedStyles?: Object,
  inlineStyles?: Object,
  stepName: string,
};

const DesiredDate = ({ cancelOldContractOpts, inheritedStyles = null, inlineStyles, stepName }: Props) => {
  const {
    inheritedStyles: { formRow, foldableText, noteWrapper, errorMessage, desiredDateRadio, desiredDateInputWrapper },
  } = useContext(ChangeServiceFormSharedContext);

  const hasData = useField("cancelOldContract").input.value;

  const CancelOldContractField = useField("cancelOldContract").input.value;

  return (
    <>
      <Row className={classnames(formRow)}>
        <div className={noteWrapper}>
          <FoldableText
            className={foldableText}
            title={cancelOldContractOpts.hint.title}
            content={cancelOldContractOpts.hint.text}
            relative={true}
          />
        </div>
        <Field name="cancelOldContract" validate={required} type="radio">
          {(props: FieldRenderProps) => {
            const [radio1, radio2, radio3] = cancelOldContractOpts?.radios;
            return (
              <>
                <RadioBasic
                  label={radio1.label}
                  name="cancelOldContract"
                  value={radio1.value}
                  onChange={(value) => {
                    changeServiceFormInteraction(stepName, "ASAP");
                    return props.input.onChange(value);
                  }}
                  selected={hasData === radio1.value}
                  inheritedStyles={inheritedStyles}
                  customSytles={desiredDateRadio}
                />
                <RadioBasic
                  label={radio2.label}
                  name="cancelOldContract"
                  value={radio2.value}
                  onChange={(value) => {
                    changeServiceFormInteraction(stepName, "DATE");
                    return props.input.onChange(value);
                  }}
                  selected={hasData === radio2.value}
                  inheritedStyles={inheritedStyles}
                  customSytles={desiredDateRadio}
                />
                {/* desiredProviderChangeDate */}
                {CancelOldContractField === "CUSTOM_SWITCHING_DATE" && (
                  <div className={desiredDateInputWrapper}>
                    <DateInput
                      fieldName="desiredProviderChangeDate"
                      stepName={stepName}
                      validate={composeValidators(required, isDate)}
                    />
                  </div>
                )}
                <RadioBasic
                  label={radio3.label}
                  name="cancelOldContract"
                  value={radio3.value}
                  onChange={(value) => {
                    changeServiceFormInteraction(stepName, "ALREADY_DONE");
                    return props.input.onChange(value);
                  }}
                  selected={hasData === radio3.value}
                  inheritedStyles={inheritedStyles}
                  customSytles={desiredDateRadio}
                />
                {/* canceledMyselfDate */}
                {CancelOldContractField === "CANCELLED_ALREADY" && (
                  <div className={desiredDateInputWrapper}>
                    <DateInput
                      fieldName="canceledMyselfDate"
                      stepName={stepName}
                      validate={composeValidators(required, isDate)}
                    />
                  </div>
                )}
              </>
            );
          }}
        </Field>
        <Error name="cancelOldContract" className={errorMessage} />
      </Row>
    </>
  );
};

export default DesiredDate;
